export default function (store) {
    store.setState({
        menuState: null,
    });
}
//# sourceMappingURL=close.js.map